import React, { useEffect } from 'react';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

import Text from '~components/atoms/Text';
import PaperGoldTable from './PaperGoldTable';
import PhysicalGoldTable from './PhysicalGoldTable';
import AvailableInventorySearchAndFilterBar from './AvailableInventorySearchAndFilterBar';

import * as Styles from './_availableInventory.module.scss';
import PreciousMetalTable from './PreciousMetalTable';
import { GoldTypeEnum, MetalTypeEnum } from '~utils/enums';

const AvailableInventory = () => {
    const dispatch = useAppDispatch();

    const filters = useAppSelector(state => state.dashboard.dashboardGoldProductInventoryFilters);

    useEffect(() => {
        dispatch(
            combinedActions.dashboardGetDashboardProductInventoryAttempt({
                ...filters,
                metalType: MetalTypeEnum.Gold,
            })
        );
    }, [filters.branchCode]);

    return (
        <div className={Styles.container}>
            <div className={Styles['title-container']}>
                <Text
                    label='AVAILABLE INVENTORY'
                    className={Styles.title}
                    isBold
                />

                <AvailableInventorySearchAndFilterBar />
            </div>

            <div className={Styles['table-container']}>
                <PhysicalGoldTable />

                <PaperGoldTable />

                <PreciousMetalTable />

            </div>
        </div>
    );
};

export default AvailableInventory;
